import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f00b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projWindow" }
const _hoisted_2 = { class: "projectTagFilter" }
const _hoisted_3 = {
  class: "group_select",
  style: {"width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"width":"100%"} }, "可选分组：", -1))
const _hoisted_5 = { class: "ProjectListTable" }
const _hoisted_6 = { key: 0 }

import { ProjectGetters, ProjectActions, ProjectMutations } from '@/store/modules/project';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onUnmounted, reactive, ref, watchEffect, watch } from 'vue';
import { CreateProjectForm, projectAPI, UpdateProjectForm } from '@/api/project';
import type { FormInstance } from 'element-plus'
import { Project } from "@/store/modules/project/types";
import { TaskGetters, TaskMutations } from "@/store/modules/task";
import { UserGetters } from '@/store/modules/user';
import LoaderGenerateConfig from "@/components/loaderGenerator/loaderGenerateConfig.vue";
import { InfoFilled } from '@element-plus/icons-vue'
import { ElSelect, ElMessage } from 'element-plus'

import { defineComponent } from 'vue';
import { formToJSON } from 'axios';
const __default__ = defineComponent({
    name: 'ProjectListTable',
});



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const formRef = ref<FormInstance>()
const store = useStore();
const router = useRouter();
const createToolVisible = ref<boolean>(false);
const createDialogFormVisible = ref(false);
const createGroupValue = ref<string[]>([])
const updateDialogFormVisible = ref(false);
const editGroupVisible = ref(false);
const selectedGroup = ref<string[]>([])
const selectedProject = ref<Project>()
const inputVisible = ref(false)
const InputRef = ref<InstanceType<typeof ElSelect>>()
const inputValue = ref('')
const groupListDisplay = ref<string[]>([])

const userinfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});
const projectList = computed(() => {
    return store.getters[`project/${ProjectGetters.getProjectList}`];
});
const projectListDisplay = computed(() => {
    if (selectedGroup.value.length === 0) {
        return projectList.value;
    } else {
        return projectList.value.filter(item => checkFilter(item))
    }
});
const checkFilter = (item: Project) => {
    let groups: string[] = selectedGroup.value
    for (let i = 0; i < groups.length; i++) {
        if (!item.group.split(",").includes(groups[i])) {
            return false
        }
    }
    return true
}

const isLoading = computed(() => {
    return store.getters[`project/${ProjectGetters.getLoading}`];
})
const groupList = computed(() => {
    return store.getters[`project/${ProjectGetters.getProjectGroup}`];
})
const taskGenerateStatus = computed(() => {
    return store.getters[`task/${TaskGetters.getCreateStatus}`];
});

const createProjectForm: CreateProjectForm = reactive({
    name: "",
    description: "",
    group: "",
});

const checkTagOnChange = (tag: string) => {
    let groups: string[] = selectedGroup.value
    if (selectedGroup.value.includes(tag)) {
        groups = groups.filter(item => item !== tag)
    } else {
        groups.push(tag)
    }
    selectedGroup.value = groups
}

const editGroup = (row: Project) => {
    selectedProject.value = row
    editGroupVisible.value = true
}

const deleteTag = (tag: string) => {
    if (selectedProject.value !== undefined) {
        let tagSlice = selectedProject.value.group.split(',')
        tagSlice.splice(tagSlice.indexOf(tag), 1)
        selectedProject.value.group = tagSlice.join(',')
    }
}
const showInput = () => {
    inputVisible.value = true
}

watch(groupList, (newVal: any, oldVal: any) => {
    getGroupListDisplay()
})

const getGroupListDisplay = () => {
    let res: string[] = []
    for (let i = 0; i < groupList.value.length; i++) {
        res.push(groupList.value[i])
    }
    groupListDisplay.value = res
}

watch(editGroupVisible, (newValue: any, oldValue: any) => {
    if (editGroupVisible.value === false) {
        inputVisible.value = false
    }
});
watch(updateDialogFormVisible, (newValue: any, oldValue: any) => {
    if (updateDialogFormVisible.value === false) {
        inputVisible.value = false
    }
});

const handleSelectComfirm = () => {
    if (createGroupValue.value.length !== 0) {
        if (createGroupValue.value[createGroupValue.value.length - 1].includes(',')) {
            createGroupValue.value.pop()
            ElMessage({
                message: '分组名内不能包含字符","',
                type: 'error',
            })
        } else if (createGroupValue.value[createGroupValue.value.length - 1].includes('新建:')) {
            let res = createGroupValue.value[createGroupValue.value.length - 1].replace('新建:', '')
            createGroupValue.value.pop()
            createGroupValue.value.push(res)
        }
    }
}

const handleInputConfirm = () => {
    if (inputValue.value && selectedProject.value !== undefined) {
        let tagSlice = selectedProject.value.group.split(',')
        if (tagSlice.includes(inputValue.value)) {
            ElMessage({
                message: '该分组已存在',
                type: 'error',
            })
        } else if (inputValue.value.includes(',')) {
            ElMessage({
                message: '分组名内不能包含字符","',
                type: 'error',
            })
        } else if (inputValue.value.includes('新建:')) {
            tagSlice.push(inputValue.value.replace('新建:', ''))
            selectedProject.value.group = tagSlice.filter(item => item !== '').join(',')
        } else {
            tagSlice.push(inputValue.value)
            selectedProject.value.group = tagSlice.filter(item => item !== '').join(',')
        }
    }
    inputVisible.value = false
    inputValue.value = ''
}

const filterMethod = (query: any) => {
    getGroupListDisplay()
    if (groupList.value.includes(query) || query === '') {
        groupListDisplay.value = groupListDisplay.value.filter(item => item.includes(query))
    } else {
        let groups: string[] = []
        groups.push('新建:' + query)
        groups = groups.concat(groupListDisplay.value.filter(item => item.includes(query)))
        groupListDisplay.value = groups
    }
}

const handleSparrowGen = (proj: Project) => {
    store.commit(`task/${TaskMutations.setSelectedProj}`, proj.id);
    createToolVisible.value = true;
};

const updateProjectForm: UpdateProjectForm = reactive({
    id: "",
    name: "",
    description: "",
    group: "",
});

const handleDetails = (id: string): void => {
    router.push({
        name: 'ProjectDetails',
        params: { projId: id },
    });
};

const handleDelete = async (id: string) => {
    const deleteProjectRes = await store.dispatch(`project/${ProjectActions.asyncDeleteProject}`, id);
}

const handleUpdate = async (row: Project) => {
    selectedProject.value = row
    const targetProject = await projectAPI.getProjectById(row.id)
    updateDialogFormVisible.value = true
    updateProjectForm.id = targetProject.id
    updateProjectForm.name = targetProject.name
    updateProjectForm.description = targetProject.description
}

const createOnSubmit = async (formEl: FormInstance | undefined) => {
    createProjectForm.group = createGroupValue.value.join(',')
    const createProjectRes = await store.dispatch(`project/${ProjectActions.asyncCreateProject}`, createProjectForm);
    if (createProjectRes == true) {
        createDialogFormVisible.value = false
    } else {
        createDialogFormVisible.value = true
    }
    if (!formEl) return
    createGroupValue.value = []
    formEl.resetFields()
}
const createOnCancel = (formEl: FormInstance | undefined) => {
    createDialogFormVisible.value = false
    if (!formEl) return
    createGroupValue.value = []
    formEl.resetFields()
}


const updateOnSubmit = async () => {
    if (selectedProject.value !== undefined) {
        updateProjectForm.group = selectedProject.value.group
        const updateProjectRes = await store.dispatch(`project/${ProjectActions.asyncUpdateProject}`, updateProjectForm);
        if (updateProjectRes == true) {
            updateDialogFormVisible.value = false
        } else {
            updateDialogFormVisible.value = true
        }
    }
}

const updateGroupOnSubmit = async () => {
    const res = await store.dispatch(`project/${ProjectActions.asyncUpdateProject}`, selectedProject.value);
    if (res == true) {
        editGroupVisible.value = false
    } else {
        editGroupVisible.value = true
    }
}


watchEffect(() => {
    if (taskGenerateStatus.value === "success") {
        createToolVisible.value = false;

    }
});

onUnmounted(() => {
    store.commit(`project/${ProjectMutations.resetAll}`);
})


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_check_tag = _resolveComponent("el-check-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(userinfo))
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: createToolVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createToolVisible).value = $event)),
          title: "工具生成配置",
          width: "50%"
        }, {
          default: _withCtx(() => [
            _createVNode(LoaderGenerateConfig, { taskGenerateStatus: _unref(taskGenerateStatus) }, null, 8, ["taskGenerateStatus"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, {
      class: "create-project",
      type: "primary",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (createDialogFormVisible.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode("新建项目")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(ElSelect), {
            modelValue: selectedGroup.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedGroup).value = $event)),
            multiple: "",
            clearable: "",
            "reserve-keyword": false,
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            placeholder: "请选择项目分组",
            style: {"margin":"15px"},
            onChange: handleSelectComfirm
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, [
            _createVNode(_component_el_check_tag, {
              size: "large",
              checked: selectedGroup.value.includes(item),
              onChange: ($event: any) => (checkTagOnChange(item)),
              style: {"margin":"5px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1032, ["checked", "onChange"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _unref(projectListDisplay) }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "id",
              label: "ID"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "name",
              label: "名称"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_popover, {
                  placement: "top",
                  title: "所属分组",
                  width: 300,
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  default: _withCtx(() => [
                    (scope.row.group !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.group.split(','), (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, { key: item }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      style: {"float":"right"},
                      onClick: ($event: any) => (editGroup(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑分组")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "description",
              label: "简介"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "creatorName",
              label: "创建者"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                (_unref(userinfo) !== null && _unref(userinfo).priv !== 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (handleUpdate(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => (handleDetails(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (scope.row.isShared === false)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (handleSparrowGen(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("工具生成")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_unref(userinfo) !== null && _unref(userinfo).priv !== 1)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 2,
                      width: "220",
                      "confirm-button-text": "删除",
                      "cancel-button-text": "取消",
                      title: "确定删除此项目吗？ (此操作会同时删除项目内所有机器）",
                      icon: _unref(InfoFilled),
                      "icon-color": "red",
                      onConfirm: ($event: any) => (handleDelete(scope.row.id))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["icon", "onConfirm"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(isLoading)]
        ]),
        _createVNode(_component_el_dialog, {
          class: "create-project-dialog",
          modelValue: createDialogFormVisible.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createDialogFormVisible).value = $event)),
          title: "新建项目",
          "show-close": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: createProjectForm,
              "label-width": "120px",
              ref_key: "formRef",
              ref: formRef
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "项目名称:",
                  prop: "name",
                  rules: [{ required: true, message: 'project name is required' },]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: createProjectForm.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createProjectForm.name) = $event)),
                      placeholder: "请输入项目名称",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "项目描述:",
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: createProjectForm.description,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createProjectForm.description) = $event)),
                      type: "textarea",
                      placeholder: "请输入项目描述",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "分组:",
                  prop: "group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElSelect), {
                      modelValue: createGroupValue.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((createGroupValue).value = $event)),
                      multiple: "",
                      filterable: "",
                      clearable: "",
                      "default-first-option": "",
                      "reserve-keyword": false,
                      placeholder: "请选择项目分组",
                      style: {"width":"100%"},
                      onChange: handleSelectComfirm,
                      "filter-method": filterMethod
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupListDisplay.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (createOnSubmit(formRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("创建")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (createOnCancel(formRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (selectedProject.value !== undefined)
          ? (_openBlock(), _createBlock(_component_el_dialog, {
              key: 0,
              class: "update-project-dialog",
              modelValue: updateDialogFormVisible.value,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((updateDialogFormVisible).value = $event)),
              title: "编辑项目信息",
              "show-close": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  model: updateProjectForm,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "项目ID：",
                      prop: "id"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(updateProjectForm.id), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "项目名称：",
                      prop: "name",
                      rules: [{ required: true, message: 'project name is required' },]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: updateProjectForm.name,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((updateProjectForm.name) = $event)),
                          placeholder: "请输入修改后的项目名称（若无需修改可不填写）",
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "项目描述：",
                      prop: "description"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: updateProjectForm.description,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((updateProjectForm.description) = $event)),
                          type: "textarea",
                          placeholder: "请输入项目描述（若无需修改可不填写）",
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "分组：",
                      prop: "group"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedProject.value.group.split(',').filter(item => item !== ''), (tag) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: tag,
                            closable: "",
                            "disable-transitions": false,
                            onClose: ($event: any) => (deleteTag(tag)),
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClose"]))
                        }), 128)),
                        (inputVisible.value)
                          ? (_openBlock(), _createBlock(_unref(ElSelect), {
                              key: 0,
                              ref_key: "InputRef",
                              ref: InputRef,
                              modelValue: inputValue.value,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((inputValue).value = $event)),
                              filterable: "",
                              clearable: "",
                              "default-first-option": "",
                              "reserve-keyword": false,
                              placeholder: "请选择 / 输入",
                              onChange: handleInputConfirm,
                              "filter-method": filterMethod
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupListDisplay.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              onClick: showInput
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("+添加分组")
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: updateOnSubmit
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("更新")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (updateDialogFormVisible.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (selectedProject.value !== undefined)
          ? (_openBlock(), _createBlock(_component_el_dialog, {
              key: 1,
              modelValue: editGroupVisible.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editGroupVisible).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  model: updateProjectForm,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "项目ID：",
                      prop: "id"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(selectedProject.value.id), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "项目名称：",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(selectedProject.value.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "分组： ",
                      prop: "group"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedProject.value.group.split(',').filter(item => item !== ''), (tag) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: tag,
                            closable: "",
                            "disable-transitions": false,
                            onClose: ($event: any) => (deleteTag(tag)),
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClose"]))
                        }), 128)),
                        (inputVisible.value)
                          ? (_openBlock(), _createBlock(_unref(ElSelect), {
                              key: 0,
                              ref_key: "InputRef",
                              ref: InputRef,
                              modelValue: inputValue.value,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((inputValue).value = $event)),
                              filterable: "",
                              clearable: "",
                              "default-first-option": "",
                              "reserve-keyword": false,
                              placeholder: "请选择 / 输入",
                              onChange: handleInputConfirm,
                              "filter-method": filterMethod
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupListDisplay.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              onClick: showInput
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("+添加分组")
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: updateGroupOnSubmit
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("提交")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (editGroupVisible.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})